'use strict';

angular.module('imagetrend.components')
    .controller('hlpDodIdController', ['$scope', '$timeout', 'Logger', 'Format', 'Validation', function ($scope, $timeout, Logger, Format, Validation) {

        // Add function to mask DOD ID showing last 4 digits
        $scope.getMaskedValue = function (value) {
            if (!value || value.length < 4) {
                return value;
            }
            // Show bullet points for all but last 4 digits
            var lastFour = value.slice(-4);
            var masked = '\u2022'.repeat(value.length - 4) + lastFour;
            return masked;
        };

        // Add function to mask ALL characters
        $scope.getFullyMaskedValue = function (value) {
            if (!value) {
                return '';
            }
            // Mask all characters with bullet points
            return '\u2022'.repeat(value.length);
        };

        // Add displayValue to track what's shown in the input
        $scope.displayValue = '';
        $scope.isFocused = false;
        $scope.previousModelLength = 0;

        var validationTimeout = $timeout(function () {
            if (!$scope.requiredText) { $scope.requiredText = 'Please enter a ' + Format.label(($scope.label || $scope.name)) }

            if ($scope.vm.showDodId && $scope.recordId && !($scope.ngModel == null || $scope.ngModel == '')) {
                Logger.logAccess($scope.recordId, "DoD ID Number");
            }

            $scope.validate = function () {
                if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                    if ($scope.innerForm && $scope.innerForm.dodId) {
                        $scope.question.answer.invalid = !isEmpty($scope.innerForm.dodId.$error);
                    }
                }
                if ($scope.validation) {
                    if ($scope.innerForm && $scope.innerForm.dodId) {
                        Validation.validateQuestion($scope.innerForm.dodId, $scope.validation, $scope.ngModel).then(function (result) {
                            if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                                $scope.question.answer.invalid = !result || !isEmpty($scope.innerForm.dodId.$error) || !isEmpty($scope.innerForm.$error);
                            }
                        });
                    }
                }
            }

            if ($scope.innerForm !== undefined && $scope.innerForm.dodId !== undefined) {
                if ($scope.isRequired && ($scope.ngModel == null || $scope.ngModel == '') && !$scope.innerForm.dodId.$error.dodId) {
                    $scope.innerForm.dodId.$setValidity("required", false);
                }
                else {
                    $scope.innerForm.dodId.$setValidity("required", true);
                }
                $scope.validate();
            }

            // Initialize display value
            $scope.updateDisplayValue();
        }, 0);

        $scope.$on('$destroy', function () {
            $timeout.cancel(validationTimeout);
        });

        var isNumeric = function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        $scope.validateDodId = function (value) {
            // Guard clause: check if innerForm and dodId field exist
            if (!$scope.innerForm || !$scope.innerForm.dodId) {
                return;
            }

            if (isUndefined(value) || value === '') {
                $scope.innerForm.dodId.$setValidity("dodId", true);
                if ($scope.isRequired) {
                    $scope.innerForm.dodId.$setValidity("required", false);
                } else {
                    $scope.innerForm.dodId.$setValidity("required", true);
                }
            } else {
                // DOD ID must be exactly 10 digits
                var cleanValue = value.replace(/\D/g, ''); // Remove non-digits
                if (cleanValue.length === 10 && isNumeric(cleanValue)) {
                    $scope.innerForm.dodId.$setValidity("dodId", true);
                    $scope.innerForm.dodId.$setValidity("required", true);
                } else {
                    $scope.innerForm.dodId.$setValidity("dodId", false);
                    $scope.innerForm.dodId.$setValidity("required", true);
                }
            }
        };

        $scope.getSectionType = function (boxNumber) {
            // Always return "text" now since we're handling masking via display value
            return "text";
        }

        $scope.updateDisplayValue = function () {
            if ($scope.security == 2 || $scope.vm.showDodId) {
                // Show full DOD ID when security=2 or "Show" checkbox is checked
                $scope.displayValue = $scope.ngModel || '';
            } else if ($scope.security == 1) {
                // Security 1: Show last 4 when not focused, fully masked when focused
                if ($scope.isFocused) {
                    $scope.displayValue = $scope.getFullyMaskedValue($scope.ngModel);
                } else {
                    // When not focused, show last 4 digits
                    $scope.displayValue = $scope.getMaskedValue($scope.ngModel);
                }
            } else {
                // Security 0: ALWAYS fully masked (never show last 4)
                $scope.displayValue = $scope.getFullyMaskedValue($scope.ngModel);
            }
        };

        $scope.onInputChange = function () {
            var input = $scope.displayValue;

            if ($scope.security == 2 || $scope.vm.showDodId) {
                $scope.ngModel = input;
                $scope.validateDodId($scope.ngModel);
                return;
            }

            var currentModel = $scope.ngModel || '';
            var currentDisplayLength = input.length;

            // User is adding characters
            if (currentDisplayLength > $scope.previousModelLength) {
                // Extract all non-bullet characters from input
                var typedChars = input.replace(/\u2022/g, '');

                // Filter to only digits
                var newDigits = typedChars.replace(/\D/g, '');

                // Simply append all the typed digits to the current model
                $scope.ngModel = currentModel + newDigits;
            }
            // User is deleting characters
            else if (currentDisplayLength < $scope.previousModelLength) {
                var charsDeleted = $scope.previousModelLength - currentDisplayLength;
                $scope.ngModel = currentModel.slice(0, -charsDeleted);
            }

            // Always show fully masked while focused (for both security 0 and 1)
            $scope.displayValue = $scope.getFullyMaskedValue($scope.ngModel);
            $scope.previousModelLength = $scope.displayValue.length;
            $scope.validateDodId($scope.ngModel);
        };

        $scope.onInputFocus = function () {
            $scope.isFocused = true;

            // When focused and masked, show fully masked for both security 0 and 1
            if (!($scope.security == 2 || $scope.vm.showDodId)) {
                $scope.displayValue = $scope.getFullyMaskedValue($scope.ngModel);
                $scope.previousModelLength = $scope.displayValue.length;
            }
        };

        $scope.onInputBlur = function () {
            $scope.isFocused = false;
            $scope.previousModelLength = 0;

            $scope.updateDisplayValue();
        };

        $scope.setFields = function (value) {
            if (value != undefined) {
                $scope.vm.boxone = value;
            }
        };

        $scope.$watch('ngModel', function (ngModel) {
            if (!isUndefined(ngModel)) {
                if (isUndefined($scope.vm.boxone)) {
                    $scope.setFields(ngModel);
                }
                if ($scope.innerForm !== undefined && $scope.innerForm.dodId !== undefined) {
                    $scope.validateDodId(ngModel);
                }
                // Update display value when model changes (only if not focused)
                if (!$scope.isFocused) {
                    $scope.updateDisplayValue();
                }
            }
        });

        $scope.$watch('vm.showDodId', function () {
            // Update display when show/hide checkbox changes
            $scope.updateDisplayValue();
        });

        // Watch security setting changes
        $scope.$watch('security', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.updateDisplayValue();
            }
        });
    }])
    .directive('hlpDodId', ['Format', '$timeout', 'Logger', 'Validation', function (Format, $timeout, Logger, Validation) {
        return {
            restrict: 'AE',
            scope: {
                name: '@',
                id: '@?',
                showLabel: '@?',
                topLabel: '=?',
                showColon: '=?',
                isRequired: '=?',
                showRequired: '=?',
                isDisabled: '=?',
                change: '&?',
                ngModel: '=',
                question: '=?',
                recordId: '=?',
                label: '@?',
                title: '@?',
                requiredText: '@?',
                instructions: '@?',
                classes: '@?',
                security: '@?',
                pdf: '=?',
                validation: '=?'
            },
            replace: true,
            require: 'ngModel',
            templateUrl: 'templates/dod-id/dod-id.html',
            link: function (scope, elem, attrs, ctrl) {

                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }

                // Set default security value
                if (!attrs.security) {
                    attrs.security = '0';
                }
                // Convert string to number and assign to scope
                scope.security = parseInt(attrs.security, 10) || 0;

                scope.vm = {};
                // Only auto-show if security is 2 (show all)
                scope.vm.showDodId = scope.security == 2;
                scope.vm.boxone = "";

                scope.onChange = function (item) {
                    scope.submitted = false;
                    if (scope.innerForm && scope.innerForm.dodId) {
                        scope.innerForm.dodId.$setDirty();
                        scope.validateDodId(item);
                    }
                    ctrl.$setViewValue(item);
                    if (scope.question !== undefined && scope.question.answer !== undefined) {
                        if (scope.innerForm && scope.innerForm.dodId) {
                            scope.question.answer.invalid = !isEmpty(scope.innerForm.dodId.$error);
                        }
                    }
                    if (scope.validation) {
                        if (scope.innerForm && scope.innerForm.dodId) {
                            Validation.validateQuestion(scope.innerForm.dodId, scope.validation, scope.ngModel).then(function (result) {
                                if (scope.question !== undefined && scope.question.answer !== undefined) {
                                    scope.question.answer.invalid = !result || !isEmpty(scope.innerForm.dodId.$error) || !isEmpty(scope.innerForm.$error);
                                }
                            });
                        }
                    }
                }
                scope.log = function () {
                    if (scope.vm.showDodId && scope.recordId && !(scope.ngModel == null || scope.ngModel == '')) {
                        Logger.logAccess(scope.recordId, "DoD ID Number");
                    }
                }
                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.validate();
                    scope.submitted = true;
                });
                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            },
            controller: 'hlpDodIdController'
        };
    }])
    ;